import axios from "axios";
import { baseURL } from "./global";
import router from "../router/index";
import { ElMessage, ElLoading } from "element-plus";
import { message } from "./resetMessage";
// 创建 axios 实例
axios.defaults.baseURL = baseURL;
axios.defaults.withCredentials = true; // 允许发送cookie给后台
axios.interceptors.request.use(
	(config) => {
		config.data = JSON.stringify(config.data);
		if (sessionStorage.customer_token) {
			config.headers.Authorization = "Bearer " + sessionStorage.customer_token;
		}

		return config;
	},
	(error) => {
		return Promise.reject(error);
	}
);
//响应拦截器
axios.interceptors.response.use(
	(response) => {
		let status = response.status;
		if (status === 200) {
			if (response.data.code === 0) {
				ElMessage.error(response.data.message);
			}
			return Promise.resolve(response);
		} else {
			return Promise.reject(response);
		}
	},
	// 服务器状态码不是200的情况
	(error) => {
		if (error.response.status) {
			let status = error.response.status;
			// ElMessage.closeAll();

			switch (status) {
				case 401:
					sessionStorage.clear();
					if (error.response.config.url.includes("/auth/form")) {
						message.error(error.response.data.message);

					} else {
						message.error(error.response.data.message);
						setTimeout(() => {
							router.replace({
								path: "/login",
							});
						}, 1000);
					}
					break;
				default:
					message.error("Oops, this is a error message.");
			}
			return Promise.reject(error.response);
		}
	}
);
export function post(url, params, headers, showLoading = true) {
	let loading;
	if (showLoading) {
		loading = ElLoading.service({
			lock: true,
			text: "Loading",
			background: "rgba(0, 0, 0, 0.7)",
		});
	}
	return new Promise((resolve, reject) => {
		axios
			.post(url, params, {
				headers: headers || {
					"Content-Type": "application/json;charset=UTF-8",
				},
			})
			.then((res) => {
				if (showLoading) {
					loading.close();
				}
				resolve(res.data);
			})
			.catch((err) => {
				if (showLoading) {
					loading.close();
				}
				reject(err);
			});
	});
}
export function get(url, headers, showLoading = true) {
	let loading;
	if (showLoading) {
		loading = ElLoading.service({
			lock: true,
			text: "Loading",
			background: "rgba(0, 0, 0, 0.7)",
		});
	}
	return new Promise((resolve, reject) => {
		axios
			.get(url, {
				headers: headers,
			})
			.then((res) => {
				if (showLoading) {
					loading.close();
				}
				resolve(res.data);
			})
			.catch((err) => {
				if (showLoading) {
					loading.close();
				}
				reject(err);
			});
	});
}

export function deleteRe(url, params, showLoading = true) {
	let loading;
	if (showLoading) {
		loading = ElLoading.service({
			lock: true,
			text: "Loading",
			background: "rgba(0, 0, 0, 0.7)",
		});
	}
	return new Promise((resolve, reject) => {
		axios
			.delete(url, params)
			.then((res) => {
				if (showLoading) {
					loading.close();
				}
				resolve(res.data);
			})
			.catch((err) => {
				if (showLoading) {
					loading.close();
				}
				reject(err);
			});
	});
}

export function put(url, params, headers, showLoading = true) {
	let loading;
	if (showLoading) {
		loading = ElLoading.service({
			lock: true,
			text: "Loading",
			background: "rgba(0, 0, 0, 0.7)",
		});
	}
	return new Promise((resolve, reject) => {
		axios
			.put(url, params, {
				headers: headers || {
					"Content-Type": "application/json;charset=UTF-8",
				},
			})
			.then((res) => {
				if (showLoading) {
					loading.close();
				}
				resolve(res.data);
			})
			.catch((err) => {
				if (showLoading) {
					loading.close();
				}
				reject(err);
			});
	});
}

export function exportExcel(url, method, data, name) {
	// resolve(res.data)
	axios({
		method: method,
		url: url,
		responseType: "arraybuffer",
		data: data,
	})
		.then((res) => {
			let link = document.createElement("a"); // 创建隐藏的可下载链接
			link.download = `${name}.xlsx`;
			link.style.display = "none";
			let blob = new Blob([res.data], { type: "application/vnd.ms-excel" }); // 字符内容转变成blob地址
			link.href = URL.createObjectURL(blob);
			document.body.appendChild(link);
			link.click(); // 触发点击
			document.body.removeChild(link); // 然后移除
		})
		.catch((err) => {
			console.log("err", err);
		});
}
